import { Component, OnInit, Input, ViewEncapsulation, ViewChild } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { OregonWellDataService } from '../../../services/oregon-well-data.service';
import { VoucherService } from '../../../services/voucher-service';
import { ActivatedRoute, Router } from '@angular/router';
import { FormControl, FormGroup } from '@angular/forms';
import { IBulkUploadHeaderMapping } from 'app/models/bulkUploads/bulk.upload.mapping';
import { Papa } from 'ngx-papaparse';
import { MatSort } from '@angular/material/sort';
import { MatPaginator } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
import { IBulkUploadSample } from 'app/models/bulkUploads/bulk.upload.sample';
import { ISelectListItem } from 'app/models/common/select.list.item';
import { MatDialog } from '@angular/material/dialog';
import { EditSampleComponent } from 'app/components/well/samples/edit/edit-samples.component';
import { ILab } from 'app/models/labs/lab';
import { Observable } from 'rxjs';
import { LabService } from 'app/services/lab-service';
import { map, startWith } from 'rxjs/operators';
import { DialogEditVoucherComponent } from 'app/components/vouchers/edit/voucher-edit-dialog';
import { EditWellComponent } from 'app/components/well/edit/edit-well.component';
import { ITreatmentViewModel } from 'app/models/household/treatment';
import { DialogAddTreatmentComponent } from 'app/components/households/treatments/add/add-treatment-dialog';

@Component({
  selector: 'bulk-upload-test-results',
  templateUrl: 'bulk-upload-test-results.component.html',
  styleUrls: ['./bulk-upload-test-results.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class BulkUploadTestResultsComponent implements OnInit {
  // #region variables 

  @Input('wellId')
  wellId: number = 0;
  @Input('uploadType')
  uploadType: string = '';
  loading: boolean = false;
  isLinear: boolean = true;
  formUploadGroup: FormGroup;
  files: File[] = [];
  filename: string = '';
  lines: string[] = [];
  header: string[] = [];
  delimiter: string = ',';
  validFile: boolean = false;
  voucherType: string = '';
  labDetailsId: number = 0;
  labName: string = "";
  fileContent: string = "";
  newline: string = '\n';
  returnCharacter: string = '\r';
  dataValid: boolean = false;
  postTreatment: boolean = false;
  isRetest: boolean = false;
  filteredLabs: Observable<ILab[]>;
  associateTreatmentPlan: string = 'No';
  treatmentPlans: ITreatmentViewModel[] = [];
  selectedTreatmentId: number = 0;
  createNewTreatmentPlan: boolean = false;
  loadingTreatmentPlans: boolean = false;
  sampleOrigin: string = "OHA";

  // column names
  AnalyteColumnName = "R_Analyte";
  MethodColumnName = "AnalyticalMethod";
  ResultColumnName = "R_Rslt";
  SampleDateColumnName = "SampleDate";
  VoucherIdColumnName = "VoucherID";
  SampleIdColumnName = "LabSampID";
  UnitsColumnName = "R_Units";
  ExceedanceColumnName = "Exceed_MCL";
  ClientIdColumnName = "ClientID";
  AnalysisDateColumnName = "AnalysisDate";
  TestTypeColumnName = "Test";

  // #endregion

  headerColumnMapping: IBulkUploadHeaderMapping[] = [
    {
      columnName: this.ClientIdColumnName,
      desc: "Client Id",
      required: true,
      headerIndex: -1
    },
    {
      columnName: this.VoucherIdColumnName,
      desc: "Voucher Id",
      required: true,
      headerIndex: -1,
    },
    {
      columnName: this.SampleDateColumnName,
      desc: "Sample Date",
      required: true,
      headerIndex: -1
    },
    {
      columnName: this.AnalyteColumnName,
      desc: "Analyte",
      required: true,
      headerIndex: -1
    },
    {
      columnName: this.MethodColumnName,
      desc: "Method",
      required: true,
      headerIndex: -1
    },
    {
      columnName: this.AnalysisDateColumnName,
      desc: "Analysis Date",
      required: true,
      headerIndex: -1
    },
    {
      columnName: this.ResultColumnName,
      desc: "Result",
      required: true,
      headerIndex: -1
    },
    {
      columnName: this.UnitsColumnName,
      desc: "Units",
      required: true,
      headerIndex: -1
    },

    {
      columnName: this.ExceedanceColumnName,
      desc: "Exceedance",
      required: true,
      headerIndex: -1
    },

    {
      columnName: this.TestTypeColumnName,
      desc: "Test Type",
      required: false,
      headerIndex: -1
    }
  ];
  bulkUploadSampleList: IBulkUploadSample[] = [];
  analyticalMethods: ISelectListItem[] = [];
  voucherIds: ISelectListItem[] = [];
  unitUpload: string;
  showProgressBar: boolean = false;
  fileVerified: boolean = false;
  hasError: boolean = false;
  saved: boolean = false;
  labsControl = new FormControl('');
  labs: ILab[] = [];
  createNewTreatment: boolean = false;

  displayedColumns: string[] = ['voucherId', 'samplePoint', 'analyte', 'sampleResult', 'sampleDate', 'analysisDate', 'method', 'testType','treatmentId'];
  dataSource = new MatTableDataSource<IBulkUploadSample>(this.bulkUploadSampleList);
  @ViewChild('TablePaginator') paginator: MatPaginator;
  @ViewChild('TableSort') sort: MatSort;


  //dataSourceTreatmentPlans
  displayedColumnsTreatmentPlans: string[] = ['select','treatmentId','statusOfInstall','installedBy','treatmentInstallCompletionDate','latestFilterChangeDate'];
  dataSourceTreatmentPlans = new MatTableDataSource<ITreatmentViewModel>(this.treatmentPlans);
  filterTable(event: Event) {
    let value = (event.target as HTMLInputElement).value;
    this.dataSource.filter = value.trim().toLowerCase();
  }

  constructor(public oregonWellDataService: OregonWellDataService, public voucherService: VoucherService,
    private toastr: ToastrService, private route: ActivatedRoute, private router: Router,
    public labService: LabService,
    private papaParser: Papa, public dialog: MatDialog) {
  }

  ngOnInit(): void { 
    // ngOnInit
    this.labService.getLabs().subscribe(
      result => {
        this.labs = result.filter(l => l.active);
        this.filteredLabs = this.labsControl.valueChanges.pipe(
          startWith(''),
          map(value => this._filterLabs(value || '')),
        );
        this.loading = false;
      },
      error => {
        this.toastr.error(error.message);
        this.loading = false;
      }
    );
  }

  private _filterLabs(value: string): ILab[] {
    const filterValue = value.toLowerCase();
    return this.labs.filter(option => option.labName.toLowerCase().includes(filterValue));
  }

  onChangeSelectedTreatment(treatmentId: number) {
    this.selectedTreatmentId = treatmentId;
  }

  sampleOriginChange(sampleOrigin: string) {
    this.sampleOrigin = sampleOrigin;
  }

  labChange(labDetailsId: number) {
    this.labDetailsId = labDetailsId;
    this.labName = this.labs.find(l => l.id == labDetailsId).labName;
  }

  voucherTypeChange(voucherType: string) {
    this.voucherType = voucherType;
  }

  associateTreatmentPlanChange(associateTreatmentPlanValue: string) {
    this.associateTreatmentPlan = associateTreatmentPlanValue;
  }

  onFileSelected(event: Event): void {
    this.validFile = false;
    this.files = [];
    let newFiles: File[] = Array.from((event.target as HTMLInputElement).files);

    newFiles.forEach((file) => {
      this.files.push(file);
      this.filename = file.name;

      if (!(this.filename.endsWith('.csv') || this.filename.endsWith('.txt'))) {
        this.files = [];
        this.filename = "";
        this.toastr.error("Invalid file type");
      }
      else {
        this.filename = file.name;

        this.files[0].text().then(
          (result) => {
            this.parseFile(result);
            this.validateFile();
          }
        );
      }
    });

    (event.target as HTMLInputElement).value = '';
  }

  parseFile(filecontent: string) {
    this.fileContent = filecontent;

    if (filecontent == null) {
      return;
    }

    let headerFound = false;
    let allLines = filecontent.split(this.newline);

    if (allLines.length > 0) {

      // loop through lines until you come to the 
      // 1st non empty row & parse that as the header
      allLines.forEach(line => {
        if (!headerFound && line.length > 0) {
          this.header = line.replace(this.newline, '').replace(this.returnCharacter, '').split(this.delimiter);

          // pre-map the header columns
          this.headerColumnMapping.forEach(hcm => {
            hcm.headerIndex = this.header.indexOf(hcm.columnName);
          });

          headerFound = true;
        }
        else {
          this.lines.push(line);
        }
      });
    }
  }

  editTreatment(treatmentId: number, housingUnitId: number) {
    const dialogRef = this.dialog.open(DialogAddTreatmentComponent, {
      width: '90%',
      data: {
        treatmentId: treatmentId,
        housingUnitId: housingUnitId
      }, 
    });
    dialogRef.afterClosed().subscribe(result => {
    });
  }

  headerMappingsIncomplete(): boolean {
    return this.headerColumnMapping.findIndex(hcm => hcm.headerIndex == -1 && hcm.required) != -1;
  }

  parseData() {
    this.dataValid = false;

    if (!this.headerMappingsIncomplete) {
      this.toastr.error("Please update column mappings");
      return;
    }

    if (!this.fileVerified) {
      this.lines.forEach(line => {
        this.papaParser.parse(line.replace(this.returnCharacter, '').replace(this.newline, ''), {
          complete: (result) => {
            if (result.data != null && result.data.length > 0) {
              if (!(result.data[0].toString().replace(/,/g, "").replace(/\s/g, "").length == 0)) {
                try {
                  this.bulkUploadSampleList.push(
                    {
                      analyte: this.analyteConversion(result.data[0][this.headerColumnMapping.find(hcm => hcm.columnName == this.AnalyteColumnName).headerIndex]),
                      exceedance: result.data[0][this.headerColumnMapping.find(hcm => hcm.columnName == this.ExceedanceColumnName).headerIndex],
                      method: this.methodConversion(result.data[0][this.headerColumnMapping.find(hcm => hcm.columnName == this.MethodColumnName).headerIndex]),
                      result: result.data[0][this.headerColumnMapping.find(hcm => hcm.columnName == this.ResultColumnName).headerIndex],
                      sampleDate: result.data[0][this.headerColumnMapping.find(hcm => hcm.columnName == this.SampleDateColumnName).headerIndex],
                      voucherId: result.data[0][this.headerColumnMapping.find(hcm => hcm.columnName == this.VoucherIdColumnName).headerIndex].trim(),
                      unit: result.data[0][this.headerColumnMapping.find(hcm => hcm.columnName == this.UnitsColumnName).headerIndex],
                      clientId: result.data[0][this.headerColumnMapping.find(hcm => hcm.columnName == this.ClientIdColumnName).headerIndex],
                      analysisDate: result.data[0][this.headerColumnMapping.find(hcm => hcm.columnName == this.AnalysisDateColumnName).headerIndex],
                      voucherType: this.voucherType,
                      labDetailsId: this.labDetailsId,
                      sampleId: "",
                      wellId: 0,
                      verified: false,
                      hasError: false,
                      voucherIdError: false,
                      voucherIdErrorMessage: "",
                      analyteName: '',
                      analyteError: false,
                      analyteErrorMessage: "",
                      methodError: false,
                      methodErrorMessage: "",
                      unitError: false,
                      unitErrorMessage: "",
                      numberOfTests: 0,
                      postTreatment: this.postTreatment,
                      isRetest: this.isRetest,
                      testType: result.data[0][this.headerColumnMapping.find(hcm => hcm.columnName == this.TestTypeColumnName).headerIndex],
                      voucherIdentifier: "",
                      createdDate: "",
                      treatmentId: 0,
                      createNewTreatment: this.createNewTreatment,
                      housingUnitId: 0,
                      sampleOrigin: "OHA"
                    });
                }
                catch (error) {
                  this.toastr.error("An Error occured parsing the File " + error);
                }
              }
            }
          }
        });
      });

      // verify
      this.showProgressBar = true;
      this.verifyData();
    }
  }

  analyteConversion(analyte: string): string {


    if(analyte == null || analyte == undefined || analyte == '') {
      return '';
    }

    if (analyte.trim().toLowerCase().includes('nitrate as n')) {
      return 'Nitrate';
    }
    if (analyte.trim().toLowerCase().includes('total coliforms')) {
      return 'Total Coliform';
    }
    if (analyte.trim().toLowerCase().includes('hardness, calculated')) {
      return 'Hardness as Calcium Carbonate';
    }
    if (analyte.trim().toLowerCase().includes('e. coli')) {
      return 'E. Coli';
    }

    return analyte.trim();
  }

  methodConversion(method: string): string {


    if(method == null || method == undefined || method == '') {
      return '';
    }

    if (method.trim().toUpperCase().includes('SM 2340B')) {
      return 'APHA 2340';
    }
    if (method.trim().toUpperCase().includes('COLIFORMS BY 9223B')) {
      return 'APHA 9223-B';
    }
    if (method.trim().toUpperCase().includes('SM 4500 NO3')) {
      return 'APHA 4500-NO3(D)';
    }

    return method.trim();
  }

  verifyData() {
    this.voucherService.VerifyBulkUploadSamples(this.bulkUploadSampleList).subscribe(
      result => {
        this.bulkUploadSampleList = result;

        if (this.bulkUploadSampleList.find(a => a.analyteError === true)
          || this.bulkUploadSampleList.find(m => m.methodError === true)
          || this.bulkUploadSampleList.find(u => u.unitError === true)
          || this.bulkUploadSampleList.find(v => v.voucherIdError === true)) {

          this.hasError = true;

          if (this.bulkUploadSampleList.find(v => v.methodError === true)) {
            if (this.analyticalMethods.length == 0) {
              this.voucherService.GetAnalyticalMethods().subscribe(methodResult => {
                this.analyticalMethods = methodResult;
              },
                error => {
                  this.oregonWellDataService.showToastError("Error occured looking up Analytical Methods");
                }
              );
            }
          }

          if (this.bulkUploadSampleList.find(v => v.voucherIdError === true)) {
            if (this.voucherIds.length == 0) {
              this.voucherService.GetVoucherIds().subscribe(voucherResult => {
                this.voucherIds = voucherResult;
              },
                error => {
                  this.oregonWellDataService.showToastError("Error occured looking up Voucher Ids");
                }
              );
            }
          }
        }
        else {
          this.hasError = false;
        }
      },
      error => {
        this.oregonWellDataService.showToastError("Error(s) occured in the Verification process of the Uploaded File");
      },
      () => {
        this.fileVerified = true;
        if(this.postTreatment && this.associateTreatmentPlan == 'Yes') {
          this.getTreatmentPlans();
        }
        this.showProgressBar = false;
        this.dataSource = new MatTableDataSource<IBulkUploadSample>(this.bulkUploadSampleList);
        this.dataSource.paginator = this.paginator;
        this.dataSource.sort = this.sort;
      }
    );
  }

  getTreatmentPlans() {
     let voucherIds = this.bulkUploadSampleList.map(b => b.voucherId);
     if(voucherIds.length == 0) {
        this.createNewTreatmentPlan = true;
     }
     else {
      this.loadingTreatmentPlans = true;
      this.voucherService.getTreatmentPlansByVoucherIds(voucherIds).subscribe(result => {
        this.treatmentPlans = result;
        this.dataSourceTreatmentPlans = new MatTableDataSource<ITreatmentViewModel>(this.treatmentPlans);
        if(this.treatmentPlans.length == 0) {
          this.createNewTreatmentPlan = true; 
        }
        else {
          this.createNewTreatmentPlan = false;
        }
        this.loadingTreatmentPlans = false;
      },
      error => {
        this.oregonWellDataService.showToastError("Error occured looking up Treatment Plans");
        this.loadingTreatmentPlans = false;
      });
    }
  }

  getAnalyteDisplayName() {
    for (var key in this.bulkUploadSampleList) {
      this.bulkUploadSampleList[key].analyteName = this.oregonWellDataService.contaminants.find(a => a.value === this.bulkUploadSampleList[key].analyte).text;
    }
  }

  validateFile() {
    this.validFile = false;
    //validate the file
    if (this.fileContent == null || this.fileContent.length == 0) {
      this.toastr.error("Null or Empty File");
      return;
    }

    //validate there is a header
    if (this.header == null || this.header.length == 0) {
      this.toastr.error("Header not found");
      return;
    }

    //validate the file has multiple lines
    if (this.lines == null || this.lines.length == 0) {
      this.toastr.error("No Sample Data");
      return;
    }

    this.validFile = true;
  }

  onSubmit() {
    //set the selected treatmentId
    this.bulkUploadSampleList.forEach(sample => {
      sample.treatmentId = this.selectedTreatmentId;
      sample.createNewTreatment = this.createNewTreatment;
      sample.sampleOrigin = this.sampleOrigin;
    });
    this.voucherService.SaveBulkUpload(this.bulkUploadSampleList).subscribe(
      result => {
        this.saved = true;
        this.removeStagedFile();
        this.bulkUploadSampleList = result;
        this.oregonWellDataService.showToastSucess("Bulk Upload was successful");
      },
      error => {
        this.saved = false;
        this.oregonWellDataService.showToastError("Bulk Upload failed");
      },
      () => {
        this.displayedColumns = ['sampleId', 'wellId', 'voucherId', 'numberOfTests', 'sampleDate', 'analysisDate', 'createdDate'];
        this.dataSource = new MatTableDataSource<IBulkUploadSample>(this.bulkUploadSampleList);
        this.dataSource.paginator = this.paginator;
        this.dataSource.sort = this.sort;
      }
    );
  }

  editSample(sampleId: number) {
    this.dialog.open(EditSampleComponent, {
      width: '90%',
      data: sampleId
    });
  }

  editWell(id: number) {
    this.dialog.open(EditWellComponent, {
      width: '90%',
      data: id
    });
  }

  editVoucher(id: number) {
    this.dialog.open(DialogEditVoucherComponent, {
      width: '90%',
      data: id
    });
  }

  removeStagedFile() {
    this.files = [];
    this.filename = "";
    this.fileVerified = false;
    this.hasError = false;
    this.lines = [];
    this.bulkUploadSampleList = [];
  }

  resetUpload() {
    this.labName = '';
    this.saved = false;
    this.voucherType = '';
    this.labsControl.setValue('');
    this.labDetailsId = 0;
    this.bulkUploadSampleList = [];
    this.displayedColumns = ['voucherId', 'samplePoint', 'analyte', 'sampleResult', 'sampleDate'];
    this.removeStagedFile();
  }
}